import { render, staticRenderFns } from "./meuQrCode.vue?vue&type=template&id=771e7c21"
import script from "./meuQrCode.vue?vue&type=script&lang=ts"
export * from "./meuQrCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports